module.exports = __webpack_public_path__ + "static/media/success-notify.3626b7ce.svg";